<template>
  <div class="rackItemContainer">
    <div
      class="rack-img-container"
      draggable
      @dragstart="$event => startDrag($event)"
      @drop="$event => endDrag($event)"
      @dragover.prevent
      @dragenter.prevent
      @contextmenu="$event => openMenu($event)"
      @click="selectPosition"
    >
      <img
        v-if="position.data && !position.active"
        class="rack-img-drawer"
        :class="[position.data ? position.data.topOrBottom : null, position.opacity ? 'opacity' : null]"
        :src="require(`@/assets/racks/drawer-5.png`)"
      />
      <img
        v-else-if="position.data && position.active"
        class="rack-img-drawer-selected"
        :class="[position.data ? position.data.topOrBottom : null, position.active ? `${position.data.topOrBottom}-selected`: null]"
        :src="require(`@/assets/racks/drawer-5-selected.png`)"
      />
      <img
        v-else-if="!(!!position.data) && !position.active"
        class="rack-img"
        :src="require(`@/assets/racks/drawer-3.png`)"
      />
      <img
        v-else
        class="rack-img-selected"
        :src="require(`@/assets/racks/drawer-3-selected.png`)"
      />
    </div>
    <p>{{ position.index + 1 }}</p>
  </div>
</template>

<script>
  export default {
    name: "RackPosition",
    components: {
    },
    props: {
      position: {
        type: Object,
      },
    },
    methods: {
      openMenu(e){
        const horizontal = e.clientX;
        const vertical = e.clientY;
        e.preventDefault();
        this.$emit('open-menu',horizontal, vertical, !(!!this.position.data), this.position);
      },
      selectPosition(){
        this.$emit('set-active-position', this.position);
      },
      startDrag(e){
        this.$emit('start-drag', e, this.position);
      },
      endDrag(e){
        this.$emit('end-drag', e, this.position);
      }
    }
  }
</script>

<style scoped>
  .rackItemContainer{
    width: 100%;
    height: 25px;
    display: flex;
    justify-content: space-between;
}
  .rackItemContainer p {
    margin: 0;
    font-size: 13px;
    font-weight: bold;
  }
  .rack-img-container{
    box-sizing: border-box;
    width: 240px;
    height: 100%;
  }
  .rack-img{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-bottom: 1px solid rgba(203, 201, 201, 0.43);
    border-radius: 5px;
  }
  .rack-img-selected{
    width: 100%;
    height: 100%;
  }
  .rack-img-drawer{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    border-left: 1px solid rgba(83, 82, 82, 0.43);
    border-right: 1px solid rgba(83, 82, 82, 0.43);
  }
  .rack-img-drawer-selected{
    height: 100%;
    width: 100%;
    border-left: 2px solid #4fa2b7 !important;
    border-right: 2px solid #4fa2b7 !important;
  }
  .position-border-top{
    border-top: 1px solid rgba(83, 82, 82, 0.43);
    border-radius: 5px 5px 0px 0px;
  }
  .position-border-bottom{
    border-bottom: 1px solid rgba(83, 82, 82, 0.43);
    border-radius: 0px 0px 5px 5px;
  }
  .position-border-top-bottom{
    border: 1px solid rgba(83, 82, 82, 0.43);
    border-radius: 5px;
  }
  .position-border-top-selected{
    border-top: 2px solid #4fa2b7;
    border-radius: 5px 5px 0px 0px;
  }
  .position-border-bottom-selected{
    border-bottom: 2px solid #4fa2b7;
    border-radius: 0px 0px 5px 5px;
  }
  .position-border-top-bottom-selected{
    border: 2px solid #4fa2b7;
    border-radius: 5px;
  }
  .opacity{
    opacity: 0.6;
  }
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/RackPosition.vue